import Collapsible from "./Collapsible";
import CollapsibleHeaderCallout from "./CollapsibleHeaderCallout";
import CollapsibleHeaderContent from "./CollapsibleHeaderContent";
import CollapsibleHeading from "./CollapsibleHeading";

export default Collapsible;
export {
  Collapsible,
  CollapsibleHeading,
  CollapsibleHeaderContent,
  CollapsibleHeaderCallout,
};
